import { useClockValue } from '@d-orca/shared/client/hooks';
import { zonedDay } from './logistics.format';

/** How often the site's calendar day is re-read. A minute late at midnight is
 *  fine. */
const ROLLOVER_CHECK_MS = 60_000;

/**
 * The site's current calendar day, re-read on a minute tick, so whatever the
 * caller renders off "today" (overdue badges, due-day asks, the waste window)
 * rolls over at the SITE's midnight instead of waiting for an unrelated
 * re-render. The host re-renders only when that day changes (`useClockValue`),
 * never on the tick itself. Null until the site's zone is known; a caller
 * that always has the zone gets a plain `string`.
 */
export function useSiteDayRollover(tz: string): string;
export function useSiteDayRollover(tz: string | undefined): string | null;
export function useSiteDayRollover(tz: string | undefined): string | null {
  return useClockValue((now) => (tz ? zonedDay(now.toISOString(), tz) : null), ROLLOVER_CHECK_MS);
}
